// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2pIX6","file":"styles_file__2DDr0"};